// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightOsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de GET /migration/os/preflight?zoho_id_unidade=&data_ini=&data_fim=
 * (controllers/migration/os.php::preflight).
 *
 * A franquia e OBRIGATORIA: o proprio Deluge recusa `id_unidade <= 0` em todas
 * as listas desta etapa, e o volume nao deixaria alternativa de qualquer jeito
 * (428k linhas na rede, ~2.141 paginas).
 *
 * O DATE RANGE e OPCIONAL nos dois extremos (decisao 43): sem nenhum dos dois
 * o pre-voo mostra a franquia inteira; so `data_ini` e "de tal dia em diante";
 * so `data_fim` e "ate tal dia". Os dois sao INCLUSIVOS e o campo filtrado e o
 * `Criado_em` da OS.
 *
 * `YYYY-MM-DD` e ESTRITO de proposito: `strtotime` aceitaria '31/01/2026' e
 * leria janeiro de 2031 sem reclamar, e o operador so descobriria pelo lote
 * vazio. Um formato so, validado com regex e checkdate.
 */
import { registerContract } from './validate'

export interface Migration_PreflightOsInput {
zoho_id_unidade?: string
data_ini?: string
data_fim?: string
ids?: string
}

registerContract('Migration_PreflightOsInput', {
  zoho_id_unidade: { type: 'string',  required: false },
  data_ini:        { type: 'string',  required: false },
  data_fim:        { type: 'string',  required: false },
  ids:             { type: 'string',  required: false },
})
